import storage from 'good-storage';
import Account from "../../service/model/Account"

const Keys = {
    UserInfo: '__u__',
    UserToken: '__t__',
    Device: '__d__',
    Account: '__a__',
    TabBar: '__b__',
    InnerTabBar: '__i__',
    AlivePage: '__p__',
    BtnPerm: '__o__',
    TatSimpleNames: '__tat__',
};

const loadUserInfo = () => {
    return storage.session.get(Keys.UserInfo, {});
};

const saveUserInfo = (user) => {
    storage.session.set(Keys.UserInfo, user);
    return user;
};

const loadUserToken = () => {
    return storage.session.get(Keys.UserToken, {});
};

const saveUserToken = (token) => {
    storage.session.set(Keys.UserToken, token);
    return token;
};

const loadAccount = () => {
    const account = storage.get(Keys.Account, new Account({}));
    if (2 * 60 * 60 * 1000 > new Date().getTime() - account.t) {
        return account;
    }
    account.p = "";
    return account;
};


const saveAccount = (account) => {
    storage.set(Keys.Account, account);
    return account;
};

const loadDevice = () => {
    return storage.session.get(Keys.Device, {});
};

const saveDevice = (device) => {
    storage.session.set(Keys.Device, device);
    return device;
};

const loadTabBar = () => {
    return storage.session.get(Keys.TabBar, {});
};

const saveTabBar = (tabBar) => {
    storage.session.set(Keys.TabBar, tabBar);
    return tabBar;
};

const loadAlivePage = () => {
    return storage.session.get(Keys.AlivePage, {});
};

const saveAlivePage = (alivePage) => {
    storage.session.set(Keys.AlivePage, alivePage);
    return alivePage;
};

const loadInnerTabBar = () => {
    return storage.session.get(Keys.InnerTabBar, {});
};

const saveInnerTabBar = (innerTabBar) => {
    storage.session.set(Keys.InnerTabBar, innerTabBar);
    return innerTabBar;
};

const loadBtnPermr = () => {
    return storage.session.get(Keys.BtnPerm, {});
};

const saveBtnPerm = (btnPerm) => {
    storage.session.set(Keys.BtnPerm, btnPerm);
    return btnPerm;
};

const loadTatSimpleNames = () => {
    return storage.session.get(Keys.TatSimpleNames, {});
};

const saveTatSimpleNames = (tatSimpleNames) => {
    storage.session.set(Keys.TatSimpleNames, tatSimpleNames);
    return tatSimpleNames;
};


export default {
    loadUserInfo,
    saveUserInfo,
    loadUserToken,
    saveUserToken,
    loadAccount,
    saveAccount,
    loadDevice,
    saveDevice,
    loadTabBar,
    saveTabBar,
    loadInnerTabBar,
    saveInnerTabBar,
    loadAlivePage,
    saveAlivePage,
    loadBtnPermr,
    saveBtnPerm,
    loadTatSimpleNames,
    saveTatSimpleNames,
}



// WEBPACK FOOTER //
// ./src/store/dao/localstorage-dao.js